import { render, staticRenderFns } from "./scientistdtail.vue?vue&type=template&id=797827de&scoped=true"
import script from "./scientistdtail.vue?vue&type=script&lang=js"
export * from "./scientistdtail.vue?vue&type=script&lang=js"
import style0 from "./scientistdtail.vue?vue&type=style&index=0&id=797827de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797827de",
  null
  
)

export default component.exports